import SignIn from "../pages/signIn/index";
import Employee from "../pages/employee/index";
import NotFoundPage from "../pages/notFoundPage";
import JobTitle from "../pages/jobTitle/index";
import Apartments from "../pages/apartments/index";
import OnLeave from "../pages/onLeave/index";
import ReceiveSalary from "../pages/receiveSalary/index";
import TimeKeeping from "../pages/timeKeeping";
import Customers from "../pages/customers";
import CustomerCare from "../pages/customerCare";
import Booking from "../pages/booking";
import OpenForSale from "../pages/openForSale";
import ProjectManagement from "../pages/projectManagement";
import PersonnelCategories from "../pages/personnelCategories";
import OnLeaveCategories from "../pages/onLeaveCategories";
import ProjectCategories from "../pages/projectCategories";
import AdminManagement from "../pages/adminManagement";
import { ROLES_CONFIG } from "../utils";
import Contract from "../pages/contract";
import bookingManagement from "../pages/bookingManagement";
import Locking from "../pages/locking";
import CommissionConfirmation from "../pages/commissionConfirmation";
import SalesManagement from "../pages/SalesManagement";
import Statement from "../pages/statement";
import ForgotPassword from "../pages/forgotPassword";
import ChangePassword from "../pages/changePassword";
import ServiceFee from "../pages/serviceFee";
import SettingManagement from "../pages/settingManagement";
import CustomerUpdateRequest from "../pages/customersUpdateRequest";
import Ttkq from "../pages/ttkq";
import LockingStatement from "../pages/lockingStatement";
import RelativeFormRequest from "../pages/RelativeFormRequest";
import BookingStatement from "../pages/bookingStatement";
import SaleContractStatement from "../pages/contractStatement";
import TtkqStatement from "../pages/ttkqStatement";
import StatementDetail from "../pages/statementDetail";
import RegisterCheckIn from "../pages/registerCheckIn";
import ServiceFeeManagement from "../pages/serviceFeeManagement";
import ServiceFeeManagementStep1 from "../pages/serviceFeeManagement/step1";
import Logs from "../pages/logs";
import TransferRequests from "../pages/transferRequests";
import BrokerDebtCertificate from "../pages/brokerDebtCertificate";
import BrokerDebtDisbursement from "../pages/brokerDebtDisbursement";
import StepCommission from "../pages/stepCommission";
import Disbursement from "../pages/disbursement";
import MakeupWorkRequest from "../pages/makeupWorkRequest";
import UpdateProjectMechanism from "../pages/updateProjectMechanism";
// Design banner
import DesignBackgroundEditorPage from "../pages/designBackground";
import Step1Name from "../pages/designBackground/create/Step1Name";
import Step2Upload from "../pages/designBackground/create/Step2Upload";
import Step3Generate from "../pages/designBackground/create/Step3Generate";
import Step4Editor from "../pages/designBackground/create/Step4Editor";
//
import UpdateProjectMechanismImport from "../pages/updateProjectMechanismImport";
import DeviceActivityLog from "../pages/deviceActivityLog";
// LOG TẠM 16/10: trang ẩn xem log chấm vào / chấm ra (không có trên menu)
import CheckinDebugLog from "../pages/checkinDebugLog";
import DeviceManager from "../pages/deviceManager";
import FuelAllowance from "../pages/fuelAllowance";
import DeleteCommission from "../pages/deleteCommission";
import CheckCommission from "../pages/checkCommission";
import AttendanceSummary from "../pages/attendanceSummary";
import EmployeeStopWorking from "../pages/employeeStopWorkingList";
import EmployeeKPI from "../pages/employeeKPI";
import EmployeeKPIList from "../pages/employeeKPIList";
import EmployeeKPIDetail from "../pages/employeeKPIDetail";
import ReferralEarning from "../pages/referralEarning";

export const routes = [
  {
    path: "/change-password",
    page: ChangePassword,
    isShowHeader: false,
    role: ROLES_CONFIG.ROUTES.ChangePassword,
  },
  {
    path: "/forgot",
    page: ForgotPassword,
    isShowHeader: false,
    role: ROLES_CONFIG.ROUTES.ForgotPassword,
  },
  {
    path: "/login",
    page: SignIn,
    isShowHeader: false,
    role: ROLES_CONFIG.ROUTES.SignIn,
  },

  {
    path: "*",
    page: NotFoundPage,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.NotFoundPage,
  },
  // menu 1
  {
    path: "/",
    page: Employee,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.Employee,
    comment: "Quản lý nhân viên",
  },
  {
    path: "/timekeeping",
    page: TimeKeeping,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.TimeKeeping,
    comment: "Quản lý chấm công",
  },
  {
    path: "/register-checkin",
    page: RegisterCheckIn,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.RegisterCheckIn,
    comment: "Quản lý đăng kí chấm công ngoài",
  },
  {
    path: "/on-leave",
    page: OnLeave,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.OnLeave,
    comment: "Xin nghỉ phép",
  },
  {
    path: "/job-title",
    page: JobTitle,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.JobTitle,
    comment: "Xác nhận công và chức danh hàng tháng",
  },
  {
    path: "/receive-salary",
    page: ReceiveSalary,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.ReceiveSalary,
    comment: "Xin nhận lương",
  },
  {
    path: "/relative-form-request",
    page: RelativeFormRequest,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.ReceiveSalary,
    comment: "Phiêu đăng ký cộng tác viên",
  },
  {
    path: "/make-up-work-request",
    page: MakeupWorkRequest,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.MakeupWorkRequest,
    comment: "Đăng ký làm bù",
  },
  {
    path: "/attendance-summary",
    page: AttendanceSummary,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.attendanceSummary,
    comment: "Quản lý chuyên cần",
  },
  {
    path: "/activity-log",
    page: DeviceActivityLog,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.DeviceActivityLog,
    comment: "Quản lý đăng nhập",
  },
  {
    path: "/device-manager",
    page: DeviceManager,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.DeviceManager,
    comment: "Quản lý đăng nhập",
  },
  {
    path: "/fuel-allowance",
    page: FuelAllowance,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.FuelAllowance,
    comment: "Quản lý xăng xe",
  },
  {
    path: "/employee-stop-working",
    page: EmployeeStopWorking,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.Employee,
    comment: "Thông báo nhân viên dừng hoạt động",
  },
  {
    path: "/employee-kpi-list",
    page: EmployeeKPIList,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.Employee,
    comment: "Quản lý đánh giá KPI nhân viên",
  },
  {
    path: "/employee-kpi",
    page: EmployeeKPI,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.Employee,
    comment: "Quản lý đánh giá KPI nhân viên",
  },
  {
    path: "/employee-kpi-list/detail",
    page: EmployeeKPIDetail,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.Employee,
    comment: "Quản lý đánh giá KPI nhân viên",
  },
  {
    path: "/referral-earning",
    page: ReferralEarning,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.Employee,
    comment: "Quản lý thưởng giới thiệu",
  },
  // menu 2
  {
    path: "/project-management",
    page: ProjectManagement,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.ProjectManagement,
    comment: "Quản lý dự án",
  },
  {
    path: "/apartments",
    page: Apartments,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.Apartments,
    comment: "Quản lý sản phẩm và căn hộ",
  },
  {
    path: "/booking",
    page: Booking,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.Booking,
    comment: "Đợt nhận booking",
  },
  {
    path: "/ttkq",
    page: Ttkq,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.Ttkq,
    comment: "Đợt nhận Ttkq",
  },
  {
    path: "/hdmb",
    page: Contract,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.Contract,
    comment: "Đợt nhận contract",
  },
  // menu 3
  {
    path: "/open-for-sale",
    page: OpenForSale,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.OpenForSale,
    comment: "Quản lý đợt mở bán",
  },
  {
    path: "/customer",
    page: Customers,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.Customers,
    comment: "Quản lý khách hàng",
  },
  {
    path: "/customer-care",
    page: CustomerCare,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.Customers,
    comment: "Chăm sóc khách hàng",
  },
  {
    path: "/customerUpdateRequest",
    page: CustomerUpdateRequest,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.CustomerUpdateRequest,
    comment: "Quản lý phiếu chỉnh sửa khách hàng",
  },
  {
    path: "/bookingManagement",
    page: bookingManagement,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.BookingManagement,
    comment: "Quản lý booking",
  },
  {
    path: "/locking",
    page: Locking,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.Locking,
    comment: "Quản lý locking",
  },
  {
    path: "/step-commission",
    page: StepCommission,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.Locking,
    comment: "Quản lý đợt thanh toán",
  },
  {
    path: "/step-commission/disbursement",
    page: Disbursement,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.Locking,
    comment: "Quản lý đợt thanh toán",
  },
  {
    path: "/service-fee-management",
    page: ServiceFeeManagement,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.Locking,
    comment: "Quản lý phí dịch vụ",
  },
  {
    path: "/broker-debt-certificate",
    page: BrokerDebtCertificate,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.BrokerDebtCertificate,
    comment: "quản lý tạm giữ CCMG",
  },
  {
    path: "/broker-debt-disbursement",
    page: BrokerDebtDisbursement,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.BrokerDebtCertificate,
    comment: "Bảng ghi thanh toán công nơ chứng chỉ môi giới",
  },
  {
    path: "/locking/calculateServiceFees/:lockingId",
    page: ServiceFeeManagementStep1,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.Locking,
    comment: "Quản lý phí dịch vụ",
  },
  {
    path: "/delete-commission",
    page: DeleteCommission,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.Locking,
    comment: "Xóa phí dịch vụ",
  },
  {
    path: "/check-commission",
    page: CheckCommission,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.Locking,
    comment: "Kiểm tra phí dịch vụ (PDV)",
  },
  {
    path: "/transfer-requests",
    page: TransferRequests,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.TransferRequests,
    comment: "Quản lý phiếu đăng ký chuyển giao dịch",
  },
  // menu 4
  {
    path: "/personnel-categories",
    page: PersonnelCategories,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.PersonnelCategories,
    comment: "Nhân sự",
  },
  {
    path: "/on-leave-categories",
    page: OnLeaveCategories,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.OnLeaveCategories,
    comment: "Công và nghỉ phép",
  },
  {
    path: "/project-categories",
    page: ProjectCategories,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.ProjectCategories,
    comment: "Dự án",
  },
  // menu 5
  {
    path: "/commission-confirmation",
    page: CommissionConfirmation,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.CommissionConfirmation,
    comment: "Xác nhận phí dịch vụ",
  },
  {
    path: "/sales-management",
    page: SalesManagement,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.SalesManagement,
    comment: "Quản lý doanh số",
  },
  {
    path: "/statement",
    page: Statement,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.Statement,
    comment: "Báo cáo",
  },
  {
    path: "/service-fee",
    page: ServiceFee,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.ServiceFee,
    comment: "Dịch vụ",
  },
  // menu 6
  {
    path: "/admin-management",
    page: AdminManagement,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.AdminManagement,
    comment: "Quản lý admin",
  },
  // menu 7
  {
    path: "/setting-management",
    page: SettingManagement,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.SettingManagement,
    comment: "Quản lý setting",
  },
  /**
   * Design banner
   */
  {
    path: "/design-background",
    page: DesignBackgroundEditorPage,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.Banner,
    comment: "Quản lý setting",
  },
  {
    path: "/design-background/create/step1",
    page: Step1Name,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.Banner,
    comment: "Bước 1",
  },
  {
    path: "/design-background/create/step2",
    page: Step2Upload,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.Banner,
    comment: "Bước 2",
  },
  {
    path: "/design-background/create/step3",
    page: Step3Generate,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.Banner,
    comment: "Bước 3",
  },
  {
    path: "/design-background/edit/:id",
    page: Step4Editor,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.Banner,
    comment: "Bước 4",
  },
  /**
   * End
   * esign
   * banner
   */

  //other
  {
    path: "/locking-statement",
    page: LockingStatement,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.Locking,
    comment: "Quản lý báo cáo locking đã duyệt",
  },
  {
    path: "/booking-statement",
    page: BookingStatement,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.Booking,
    comment: "Quản lý báo cáo booking đã duyệt",
  },
  {
    path: "/ttkq-statement",
    page: TtkqStatement,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.Ttkq,
    comment: "Quản lý báo cáo ttkq đã duyệt",
  },
  {
    path: "/sale-contract-statement",
    page: SaleContractStatement,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.Contract,
    comment: "Quản lý báo cáo hđmb đã duyệt",
  },
  {
    path: "/statement-detail",
    page: StatementDetail,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.Statement,
    comment: "Quản lý báo cáo chi tiết",
  },
  {
    path: "/logs",
    page: Logs,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.Logs,
    comment: "Logs",
  },
  // LOG TẠM 16/10: trang ẩn (không có trên menu), cùng quyền với Logs
  {
    path: "/checkin-debug-log",
    page: CheckinDebugLog,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.Logs,
    comment: "Log chấm vào / chấm ra (tạm)",
  },
  // {
  //   path: "/project-management/updateProjectMechanism/:projectId",
  //   page: UpdateProjectMechanism,
  //   isShowHeader: true,
  //   role: ROLES_CONFIG.ROUTES.ProjectManagement,
  //   comment: "Tính hệ số K",
  // },
  {
    path: "/sale-opening-event/sale-opening-event-mechanism/:saleOpeningEventId",
    page: UpdateProjectMechanism,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.OpenForSale,
    comment: "Tính hệ số K",
  },
  {
    path: "/sale-opening-event/sale-opening-event-mechanism-import/:saleOpeningEventId",
    page: UpdateProjectMechanismImport,
    isShowHeader: true,
    role: ROLES_CONFIG.ROUTES.OpenForSale,
    comment: "import giá tính PDV và TN sàn",
  },
];
